import { render, staticRenderFns } from "./Spellbook.vue?vue&type=template&id=4e1b60e9&"
import script from "./Spellbook.vue?vue&type=script&lang=js&"
export * from "./Spellbook.vue?vue&type=script&lang=js&"
import style0 from "./Spellbook.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Spellbook.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Spellbook.vue"
export default component.exports